module.exports = __webpack_public_path__ + "img/newmember_coin_ja.8d16af26.png";